export const resourcesProductboardAuth = "/resources/productboard_auth";
